@if (isPolicyPrevidenziale) {
  <app-basic-form [form]="form" [keys]="keys"></app-basic-form>
} @else {
  <div class="d-flex justify-content-center align-items-center">
    <div class="text-container">
        <h5>Stai per avviare l'operazione per la sospensione dei pagamenti del premio.</h5>
        <h5>Cliccando su <span class="text-red">Avanti</span>, confermerai l'esecuzione di tale operazione.</h5>
    </div>
</div>
}
